/*
 * ALACRAN — Intro cinematográfica
 *
 * Secuencia (≈7 s, escala con la duración elegida en el tema):
 *   1. Negro. Una línea de luz dorada abre el horizonte.
 *   2. La escena aparece: dunas al anochecer, luna, estrellas. Franjas de cine.
 *   3. El alacrán cruza despacio; la cámara se acerca.
 *   4. Se detiene, se recoge y ataca. La punta del aguijón se enciende.
 *   5. La cámara entra en esa luz: el aguijón es la llave.
 *   6. La luz se abre como un iris desde la punta y aparece la tienda.
 *
 * Corre mientras la página termina de cargar. Una vez por visita.
 */
(function () {
  'use strict';

  var root = document.getElementById('alacran-intro');
  if (!root) return;

  var html = document.documentElement;
  var KEY = 'alacran-intro-visto';
  var done = false;
  var rafId = 0;

  function remember() {
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) { /* almacenamiento bloqueado */ }
  }

  function removeRoot() {
    if (root && root.parentNode) root.parentNode.removeChild(root);
  }

  function finish(instant) {
    if (done) return;
    done = true;
    remember();
    if (rafId) cancelAnimationFrame(rafId);
    html.classList.remove('intro-activa');
    html.classList.add('intro-terminada');
    document.dispatchEvent(new CustomEvent('alacran:intro-fin'));
    if (instant) { removeRoot(); return; }
    root.classList.add('is-saliendo');
    window.setTimeout(removeRoot, 1600);
  }

  var seen = false;
  try { seen = window.sessionStorage.getItem(KEY) === '1'; } catch (e) { seen = false; }
  if (seen && !root.hasAttribute('data-always')) { finish(true); return; }

  html.classList.add('intro-activa');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var minMs = parseInt(root.getAttribute('data-min-ms'), 10) || 6700;
  var MAX_MS = minMs + 3500;
  var markAt = minMs - 2200;
  var loaded = document.readyState === 'complete';
  window.addEventListener('load', function () { loaded = true; });

  var skip = root.querySelector('[data-intro-skip]');
  if (skip) skip.addEventListener('click', function () { finish(false); });

  var shine = root.querySelector('[data-brillo]');
  var t0 = performance.now();
  var marked = false;
  function showMark() {
    if (marked) return;
    marked = true;
    root.classList.add('is-emblema');
    if (shine && shine.beginElement) {
      window.setTimeout(function () { try { shine.beginElement(); } catch (e) { /* sin SMIL */ } }, 900);
    }
  }

  function checkExit(elapsed) {
    if (elapsed >= markAt) showMark();
    if (elapsed >= minMs && (loaded || elapsed >= MAX_MS)) finish(false);
  }

  /* Sin movimiento: solo el emblema, breve. */
  if (reduce) {
    minMs = 1800; markAt = 0; MAX_MS = 4000;
    root.classList.add('is-quieta');
    (function tick() {
      if (done) return;
      checkExit(performance.now() - t0);
      rafId = requestAnimationFrame(tick);
    })();
    return;
  }

  /* Video real, si la tienda lo subió. */
  var video = root.querySelector('[data-intro-video]');
  if (video) {
    var canvasEl = root.querySelector('[data-intro-canvas]');
    if (canvasEl) canvasEl.hidden = true;
    var videoFailed = false;
    var fallback = function () {
      if (videoFailed) return;
      videoFailed = true;
      video.hidden = true;
      if (canvasEl) canvasEl.hidden = false;
      t0 = performance.now();
      startCanvas();
    };
    video.addEventListener('error', fallback);
    var playing = video.play && video.play();
    if (playing && playing.catch) playing.catch(fallback);
    (function tickVideo() {
      if (done || videoFailed) return;
      var elapsed = performance.now() - t0;
      if (video.duration && isFinite(video.duration)) {
        var d = video.duration * 1000;
        markAt = Math.max(0, d - 1300);
        minMs = d + 1200;
        MAX_MS = minMs + 3500;
      }
      checkExit(elapsed);
      rafId = requestAnimationFrame(tickVideo);
    })();
    return;
  }

  startCanvas();

  /* ------------------------------------------------------------------ */
  /*  Escena en canvas                                                   */
  /* ------------------------------------------------------------------ */
  function startCanvas() {
    var canvas = root.querySelector('[data-intro-canvas]');
    if (!canvas || !canvas.getContext) {
      minMs = 1800; markAt = 0;
      (function tickPlain() {
        if (done) return;
        checkExit(performance.now() - t0);
        rafId = requestAnimationFrame(tickPlain);
      })();
      return;
    }
    root.classList.add('modo-canvas');
    var screenCtx = canvas.getContext('2d');
    var ctx = screenCtx;

    var GOLD = '201,164,101';
    var W = 0, H = 0, dpr = 1, S = 1;
    var stars = [], prints = [], motes = [], dust = [];
    var grain = null;

    /* Línea de tiempo (ms) a 6.7 s; se escala con la duración elegida. */
    var K = minMs / 6700;
    var T = {
      lineFull: 900 * K,
      sceneIn: 600 * K, sceneFull: 1700 * K,
      walkStart: 900 * K, walkEnd: 4100 * K,
      coilEnd: 4450 * K,
      strike: 4450 * K, strikeEnd: 4670 * K,
      zoom: 4720 * K, zoomEnd: 5750 * K,
      reveal: 5750 * K, revealDur: 1150
    };
    markAt = Infinity;

    function rand(a, b) { return a + Math.random() * (b - a); }
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    function prog(t, a, b) { return clamp((t - a) / (b - a), 0, 1); }
    function easeOutCubic(x) { return 1 - Math.pow(1 - x, 3); }
    function easeInOut(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
    function easeInOutSine(x) { return -(Math.cos(Math.PI * x) - 1) / 2; }

    function groundY(x) {
      return H * 0.735 + Math.sin(x / W * Math.PI * 1.1 + 0.6) * H * 0.022 + Math.sin(x / W * Math.PI * 3.3) * H * 0.006;
    }
    function duneBack(x, t) {
      return H * 0.6 + Math.sin((x + t * 0.003 * W) / W * Math.PI * 1.6 + 1.2) * H * 0.035 + Math.sin(x / W * Math.PI * 4.1) * H * 0.008;
    }
    function duneMid(x, t) {
      return H * 0.665 + Math.sin((x + t * 0.006 * W) / W * Math.PI * 2.1 + 2.4) * H * 0.03 + Math.sin(x / W * Math.PI * 5.2 + 1) * H * 0.007;
    }

    function makeGrain() {
      var g = document.createElement('canvas');
      g.width = g.height = 160;
      var gc = g.getContext('2d');
      var img = gc.createImageData(160, 160);
      for (var i = 0; i < img.data.length; i += 4) {
        var v = Math.random() * 255;
        img.data[i] = img.data[i + 1] = img.data[i + 2] = v;
        img.data[i + 3] = 20;
      }
      gc.putImageData(img, 0, 0);
      return g;
    }

    function build() {
      stars = [];
      var n = Math.round(W * H / 11000);
      for (var i = 0; i < n; i++) {
        stars.push({ x: Math.random() * W, y: Math.pow(Math.random(), 1.6) * H * 0.55, r: rand(0.3, 1.1), a: rand(0.25, 0.9), s: rand(0.4, 1.6), p: rand(0, 6.28) });
      }
      motes = [];
      for (var j = 0; j < 55; j++) {
        motes.push({ x: Math.random() * W, y: rand(H * 0.5, H * 0.95), v: rand(5, 18), r: rand(0.4, 1.3), a: rand(0.12, 0.5), p: rand(0, 6.28) });
      }
      buildBackground();
      if (!grain) {
        grain = makeGrain();
        var layer = document.createElement('div');
        layer.className = 'a-intro__grano';
        layer.setAttribute('aria-hidden', 'true');
        try { layer.style.backgroundImage = 'url(' + grain.toDataURL() + ')'; } catch (e) { /* sin grano */ }
        var vin = document.createElement('div');
        vin.className = 'a-intro__vineta';
        vin.setAttribute('aria-hidden', 'true');
        canvas.parentNode.insertBefore(vin, canvas.nextSibling);
        canvas.parentNode.insertBefore(layer, vin.nextSibling);
      }
    }

    var dprTope = 3;
    function setDpr2D(v) {
      dpr = v;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      screenCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function resize() {
      /* Supermuestreo: en pantallas normales se pinta al doble para que el alacrán no se vea escalonado */
      var base = window.devicePixelRatio || 1;
      dpr = Math.min(dprTope, base < 2 ? base * 2 : base);
      W = root.clientWidth || window.innerWidth;
      H = root.clientHeight || window.innerHeight;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      canvas.style.width = W + 'px';
      canvas.style.height = H + 'px';
      screenCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
      S = W < 700 ? W * 0.0031 : Math.min(W * 0.0018, H * 0.0029);
      build();
    }
    window.addEventListener('resize', resize);
    resize();

    /* --- Desierto en WebGL ---------------------------------------------- */
    /* Cielo, luna, estrellas y tres capas de dunas con volumen, arena y bruma.
       El suelo del frente usa la misma curva que pisa el alacrán (groundY). */
    var VERT = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.0,1.0);}';
    var FRAG = [
      'precision highp float;',
      'uniform vec2 uRes;uniform float uDpr;uniform float uTime;uniform float uScale;uniform vec2 uOff;uniform float uStar;',
      'const float PI=3.14159265;',
      'float h21(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
      'float n2(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.0-2.0*f);',
      ' return mix(mix(h21(i),h21(i+vec2(1,0)),u.x),mix(h21(i+vec2(0,1)),h21(i+vec2(1,1)),u.x),u.y);}',
      'float fbm(vec2 p){float v=0.0,a=0.5;for(int i=0;i<3;i++){v+=a*n2(p);p=p*2.03+vec2(17.1,9.2);a*=0.5;}return v;}',
      'float r1(float x){return uRes.y*0.735+sin(x/uRes.x*PI*1.1+0.6)*uRes.y*0.022+sin(x/uRes.x*PI*3.3)*uRes.y*0.006;}',
      'float s2(float x){float u=x/uRes.x;return uRes.y*(0.028*cos(u*PI*2.1+2.4)*PI*2.1+0.008*cos(u*PI*5.2+1.0)*PI*5.2)/uRes.x;}',
      'float s3(float x){float u=x/uRes.x;return uRes.y*(0.03*cos(u*PI*1.6+1.2)*PI*1.6+0.008*cos(u*PI*4.1)*PI*4.1)/uRes.x;}',
      'float s1(float x){float u=x/uRes.x;return uRes.y*(0.022*cos(u*PI*1.1+0.6)*PI*1.1+0.006*cos(u*PI*3.3)*PI*3.3)/uRes.x;}',
      'float r2(float x){float u=x/uRes.x;return uRes.y*(0.668+0.028*sin(u*PI*2.1+2.4)+0.008*sin(u*PI*5.2+1.0)+0.02*(fbm(vec2(u*2.6,3.0))-0.5));}',
      'float r3(float x){float u=x/uRes.x;return uRes.y*(0.605+0.03*sin(u*PI*1.6+1.2)+0.008*sin(u*PI*4.1)+0.022*(fbm(vec2(u*1.8,11.0))-0.5));}',
      'vec3 dune(vec2 w,float r,float slope,float depth,vec3 base,vec3 haze,float hazeAmt,float sunX,float detail){',
      ' float d=(w.y-r)/uRes.y;',
      ' float toward=exp(-abs(w.x-sunX)/uRes.x*2.0);',
      ' vec3 c=base*(1.0-smoothstep(0.0,0.22,d)*0.55);',
      ' float lit=clamp(0.5-slope*4.0,0.0,1.0);',
      ' c+=base*0.9*lit*toward*(1.0-smoothstep(0.0,0.06,d));',
      ' float rip=sin(w.x*0.11*detail+w.y*0.42*detail+n2(w*0.012)*9.0);',
      ' c*=1.0+0.07*rip*detail*smoothstep(0.004,0.05,d);',
      ' c*=0.92+0.16*(n2(w*0.06)*0.6+n2(w*0.17)*0.4);',
      ' c+=(h21(gl_FragCoord.xy)-0.5)*0.03*detail;',
      ' float rim=exp(-d*uRes.y*0.16)*toward;',
      ' c+=vec3(1.0,0.62,0.3)*rim*(0.55+0.3*detail);',
      ' c=mix(c,haze,hazeAmt*(1.0-smoothstep(0.0,0.12,d)*0.7));',
      ' return c;}',
      'void main(){',
      ' vec2 sp=vec2(gl_FragCoord.x,uRes.y*uDpr-gl_FragCoord.y)/uDpr;',
      ' vec2 w=(sp-uOff)/uScale;',
      ' float hy=w.y/uRes.y;',
      ' vec2 sun=vec2(uRes.x*0.64,uRes.y*0.625);',
      ' vec3 top=vec3(0.010,0.012,0.030),mid=vec3(0.045,0.032,0.048),low=vec3(0.42,0.19,0.075);',
      ' vec3 col=mix(top,mid,smoothstep(0.0,0.42,hy));',
      ' col=mix(col,low,smoothstep(0.36,0.64,hy));',
      ' float sd=length((w-sun)/uRes.y*vec2(0.55,1.0));',
      ' col+=vec3(1.0,0.52,0.2)*0.6*exp(-sd*5.0)+vec3(1.0,0.78,0.5)*0.35*exp(-sd*18.0);',
      ' vec2 cell=floor(w/3.5);float hs=h21(cell);',
      ' vec2 f=fract(w/3.5)-0.5;',
      ' float st=step(0.9962,hs)*(0.55+0.45*sin(uTime*0.0015*(1.0+hs*4.0)+hs*60.0))*smoothstep(0.45,0.0,length(f));',
      ' col+=vec3(1.0,0.95,0.86)*st*uStar*(1.0-smoothstep(0.22,0.52,hy));',
      ' vec2 mc=vec2(uRes.x*0.2,uRes.y*0.2);float mr=max(10.0,min(uRes.x,uRes.y)*0.024);',
      ' float md=length(w-mc);float md2=length(w-mc-vec2(mr*0.42,-mr*0.2));',
      ' float moon=smoothstep(mr,mr-1.0,md)*smoothstep(mr*0.9-1.0,mr*0.9,md2);',
      ' if(moon>0.0){col=mix(col,vec3(0.93,0.88,0.77)*(0.82+0.18*n2(w/4.0)),moon*0.92);}',
      ' col+=vec3(0.9,0.85,0.75)*0.05*exp(-md/mr*1.2)*(1.0-moon);',
      ' float band=smoothstep(0.30,0.42,hy)*(1.0-smoothstep(0.50,0.58,hy));',
      ' float cl=fbm(vec2(w.x*0.0016+uTime*0.000004,w.y*0.012));',
      ' cl=smoothstep(0.52,0.78,cl)*band;',
      ' float lit2=exp(-abs(w.x-sun.x)/uRes.x*1.6);',
      ' col=mix(col,col*0.55,cl*0.35);',
      ' col+=vec3(1.0,0.5,0.28)*cl*0.22*lit2;',
      ' vec3 haze=vec3(0.38,0.19,0.09);',
      ' float a3=r3(w.x);',
      ' if(w.y>a3){col=dune(w,a3,s3(w.x),0.0,vec3(0.17,0.09,0.05),haze,0.7,sun.x,0.25);}',
      ' float a2=r2(w.x);',
      ' if(w.y>a2){col=dune(w,a2,s2(w.x),0.0,vec3(0.12,0.065,0.035),haze*0.7,0.42,sun.x,0.55);}',
      ' col+=vec3(0.55,0.3,0.15)*0.06*exp(-abs(w.y-a2)/uRes.y*28.0);',
      ' float a1=r1(w.x);',
      ' if(w.y>a1){col=dune(w,a1,s1(w.x),0.0,vec3(0.085,0.05,0.03),haze*0.5,0.12,sun.x,1.0);}',
      ' col=pow(col,vec3(0.95));',
      ' col+=(h21(gl_FragCoord.xy+fract(uTime*0.001)*17.0)-0.5)/180.0;',
      ' gl_FragColor=vec4(col,1.0);',
      '}'
    ].join('\n');

    var glView = null;
    function initGL() {
      var c = document.createElement('canvas');
      c.className = 'a-intro__canvas a-intro__cielo';
      c.setAttribute('aria-hidden', 'true');
      var gl = null;
      try { gl = c.getContext('webgl', { antialias: false, alpha: false, premultipliedAlpha: false, powerPreference: 'high-performance' }); } catch (e) { gl = null; }
      if (!gl) return null;
      function sh(type, src) {
        var s = gl.createShader(type);
        gl.shaderSource(s, src);
        gl.compileShader(s);
        return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
      }
      var vs = sh(gl.VERTEX_SHADER, VERT), fs = sh(gl.FRAGMENT_SHADER, FRAG);
      if (!vs || !fs) return null;
      var pr = gl.createProgram();
      gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
      if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return null;
      gl.useProgram(pr);
      var buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(pr, 'p');
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      canvas.parentNode.insertBefore(c, canvas);
      return {
        el: c, gl: gl, dpr: 0, max: 0,
        u: {
          res: gl.getUniformLocation(pr, 'uRes'), dpr: gl.getUniformLocation(pr, 'uDpr'),
          time: gl.getUniformLocation(pr, 'uTime'), scale: gl.getUniformLocation(pr, 'uScale'),
          off: gl.getUniformLocation(pr, 'uOff'), star: gl.getUniformLocation(pr, 'uStar')
        }
      };
    }

    function sizeGL() {
      if (!glView) return;
      if (!glView.max) glView.max = Math.min(window.devicePixelRatio || 1, 2);
      if (!glView.dpr) glView.dpr = glView.max;
      glView.el.width = Math.round(W * glView.dpr);
      glView.el.height = Math.round(H * glView.dpr);
      glView.el.style.width = W + 'px';
      glView.el.style.height = H + 'px';
      glView.gl.viewport(0, 0, glView.el.width, glView.el.height);
    }

    function renderGL(t, scale, ox, oy, starIn) {
      var gl = glView.gl, u = glView.u;
      gl.uniform2f(u.res, W, H);
      gl.uniform1f(u.dpr, glView.dpr);
      gl.uniform1f(u.time, t);
      gl.uniform1f(u.scale, scale);
      gl.uniform2f(u.off, ox, oy);
      gl.uniform1f(u.star, starIn);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    glView = initGL();
    sizeGL();
    window.addEventListener('resize', sizeGL);

    /* --- Alacrán ------------------------------------------------------ */
    var STRIDE = 14;
    var CYCLE = STRIDE / 0.6;
    var LIFT = 8;
    var HIPS = [17, 10, 2, -6];
    var REACH = [30, 12, -10, -28];
    var NEAR_OFF = [0.0, 0.5, 0.1, 0.6];
    var FEMUR = 24, TIBIA = 29;
    var gait = 0;
    var lastStance = [true, true, true, true];

    function footAt(i, far) {
      var off = NEAR_OFF[i] + (far ? 0.5 : 0) + i * 0.04;
      var p = (gait + off) % 1;
      if (p < 0) p += 1;
      var rest = HIPS[i] + REACH[i] * (far ? 0.86 : 1);
      if (p < 0.6) {
        var u = p / 0.6;
        return { x: rest + STRIDE * (0.5 - u), y: 0, stance: true };
      }
      var w = (p - 0.6) / 0.4;
      return { x: rest + STRIDE * (-0.5 + w), y: -Math.sin(w * Math.PI) * LIFT, stance: false };
    }

    function knee(hx, hy, fx, fy) {
      var dx = fx - hx, dy = fy - hy;
      var d = clamp(Math.sqrt(dx * dx + dy * dy), 1, FEMUR + TIBIA - 0.5);
      var th = Math.atan2(dy, dx);
      var a = Math.acos(clamp((FEMUR * FEMUR + d * d - TIBIA * TIBIA) / (2 * FEMUR * d), -1, 1));
      var k1 = { x: hx + FEMUR * Math.cos(th - a), y: hy + FEMUR * Math.sin(th - a) };
      var k2 = { x: hx + FEMUR * Math.cos(th + a), y: hy + FEMUR * Math.sin(th + a) };
      return k1.y < k2.y ? k1 : k2;
    }

    /* Geometría de un cuadro: se calcula una vez y se pinta en varias pasadas. */
    function geometry(t, pose) {
      var bob = Math.sin(gait * Math.PI * 4) * 0.45 * pose.moving;
      var by = -19 + bob;
      var g = { by: by, legs: [], palps: [], tail: [], open: pose.claw };
      [true, false].forEach(function (far) {
        for (var i = 0; i < 4; i++) {
          var hx = HIPS[i] + (far ? 2 : 0), hy = by + (far ? 1 : 2.5);
          var f = footAt(i, far);
          g.legs.push({ far: far, h: { x: hx, y: hy }, k: knee(hx, hy, f.x, f.y), f: f });
        }
        var sway = Math.sin(t * 0.0023 + (far ? 1.4 : 0)) * 0.9;
        var dx = far ? 3 : 0, dy = far ? -2.5 : 0;
        g.palps.push({
          far: far,
          a: { x: 33 + dx, y: by + 1 + dy },
          b: { x: 44 + dx, y: by - 9 + dy + sway },
          c: { x: 55 + dx, y: by - 6 + dy + sway },
          rot: -0.12 + sway * 0.02
        });
      });
      var curl = pose.curl;
      var tsway = Math.sin(t * 0.0019) * 0.035;
      var lens = [12, 12.5, 13, 13.5, 14];
      var widths = [8, 7.4, 7, 6.6, 6.4];
      var x = -41, y = by - 4;
      var wind = pose.wind || 0, strike = clamp(pose.strike || 0, 0, 1.15);
      var a0 = Math.PI + 0.52 - curl * 0.38 + tsway - wind * 0.22;
      var inc0 = 0.5 + curl * 0.095 + tsway * 0.5 - wind * 0.1;
      var a = a0 + (4.5 - a0) * strike;
      var inc = inc0 + (0.56 - inc0) * strike;
      var reach = 1 + 0.38 * strike;
      for (var j = 0; j < lens.length; j++) {
        var nx = x + Math.cos(a) * lens[j] * reach;
        var ny = y + Math.sin(a) * lens[j] * reach;
        g.tail.push({ x1: x, y1: y, x2: nx, y2: ny, w: widths[j], a: a });
        x = nx; y = ny;
        a += inc;
      }
      g.telson = { x: x, y: y, a: a - 0.2 };
      return g;
    }

    function style(mode, far) {
      if (mode === 'rim') return { c: far ? 'rgba(255,186,110,0.1)' : 'rgba(255,196,128,0.55)', g: 0.22 };
      return { c: far ? '#0c0806' : '#040302', g: 0 };
    }

    function seg(x1, y1, x2, y2, w, st) {
      ctx.strokeStyle = st.c;
      ctx.lineWidth = w + st.g * 2;
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
    }

    function solid(draw, st) {
      ctx.fillStyle = st.c;
      ctx.strokeStyle = st.c;
      ctx.lineWidth = st.g * 2;
      ctx.beginPath();
      draw();
      ctx.closePath();
      ctx.fill();
      if (st.g > 0) ctx.stroke();
    }

    function drawLegs(g, far, mode) {
      var st = style(mode, far);
      var k = far ? 0.8 : 1;
      g.legs.forEach(function (L) {
        if (L.far !== far) return;
        seg(L.h.x, L.h.y, L.k.x, L.k.y, 2.1 * k, st);
        seg(L.k.x, L.k.y, L.f.x, L.f.y, 1.45 * k, st);
        seg(L.f.x, L.f.y, L.f.x + 3.2, L.f.y + 0.3, 0.9 * k, st);
      });
    }

    function drawPalp(g, far, mode) {
      var st = style(mode, far);
      g.palps.forEach(function (P) {
        if (P.far !== far) return;
        seg(P.a.x, P.a.y, P.b.x, P.b.y, 3.0, st);
        seg(P.b.x, P.b.y, P.c.x, P.c.y, 3.4, st);
        ctx.save();
        ctx.translate(P.c.x + 9, P.c.y - 1);
        ctx.rotate(P.rot);
        solid(function () {
          ctx.moveTo(-9, 0);
          ctx.bezierCurveTo(-8, -6, 4, -7.2, 9, -3.4);
          ctx.bezierCurveTo(11, -1.6, 11, 1.6, 9, 3.2);
          ctx.bezierCurveTo(4, 6.4, -8, 5.6, -9, 0);
        }, st);
        var o = g.open;
        seg(8, -2.6, 21, -3.6 - o * 4.5, 2.1, st);
        seg(8, 2.2, 20, 2.6 + o * 3.2, 1.9, st);
        ctx.restore();
      });
    }

    function drawTail(g, mode) {
      var st = style(mode, false);
      g.tail.forEach(function (s) { seg(s.x1, s.y1, s.x2, s.y2, s.w, st); });
      ctx.save();
      ctx.translate(g.telson.x, g.telson.y);
      ctx.rotate(g.telson.a);
      solid(function () { ctx.ellipse(4.5, 0, 7.5, 5.2, 0, 0, Math.PI * 2); }, st);
      solid(function () {
        ctx.moveTo(10, -1.8);
        ctx.quadraticCurveTo(20.5, -1.2, 19.8, 10);
        ctx.quadraticCurveTo(17, 2.6, 10, 2);
      }, st);
      ctx.restore();
    }

    function drawBody(g, mode) {
      var st = style(mode, false);
      var by = g.by;
      solid(function () {
        ctx.moveTo(36, by + 1);
        ctx.bezierCurveTo(36, by - 6, 30, by - 9, 20, by - 9.5);
        ctx.bezierCurveTo(8, by - 10, -8, by - 10.8, -24, by - 9.8);
        ctx.bezierCurveTo(-34, by - 9.2, -41, by - 6.5, -43, by - 2.5);
        ctx.bezierCurveTo(-43.5, by + 2.5, -36, by + 5.2, -26, by + 5.6);
        ctx.bezierCurveTo(-10, by + 6.5, 14, by + 6, 28, by + 5);
        ctx.bezierCurveTo(34, by + 4.4, 36, by + 3, 36, by + 1);
      }, st);
    }

    function scorpionPass(g, mode) {
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      drawLegs(g, true, mode);
      drawPalp(g, true, mode);
      drawTail(g, mode);
      drawBody(g, mode);
      drawLegs(g, false, mode);
      drawPalp(g, false, mode);
    }

    /* Detalle fino: segmentos del cuerpo, articulaciones de la cola, ojos. */
    function scorpionDetail(g) {
      var by = g.by;
      ctx.lineCap = 'round';
      ctx.strokeStyle = 'rgba(255,196,130,0.07)';
      ctx.lineWidth = 0.6;
      [13, 6, -1, -8, -15, -22, -29, -36].forEach(function (x, i) {
        ctx.globalAlpha = i === 0 ? 1 : 0.85;
        ctx.beginPath();
        ctx.moveTo(x + 1.6, by - 9.8);
        ctx.quadraticCurveTo(x + 3.2, by - 2, x - 0.6, by + 5.4);
        ctx.stroke();
      });
      ctx.globalAlpha = 1;
      g.tail.forEach(function (s, i) {
        if (i === 0) return;
        var nx = -Math.sin(s.a), ny = Math.cos(s.a), h = s.w * 0.45;
        ctx.beginPath();
        ctx.moveTo(s.x1 + nx * h, s.y1 + ny * h);
        ctx.lineTo(s.x1 - nx * h, s.y1 - ny * h);
        ctx.stroke();
      });
    }

    function drawScorpion(t, pose) {
      var g = geometry(t, pose);
      ctx.save();
      ctx.translate(0.28, -0.42);
      scorpionPass(g, 'rim');
      ctx.restore();
      scorpionPass(g, 'fill');
      scorpionDetail(g);
      return g;
    }

    /* --- Utilidades de escena ----------------------------------------- */
    var FX = 0.52, FY = 0.68;
    var lastG = null;

    function applyCamera(c, cam) {
      var fx = W * FX, fy = H * FY;
      c.translate(fx, fy); c.scale(cam, cam); c.translate(-fx, -fy);
    }

    /* Punto local del alacrán → pantalla (sin el acercamiento final). */
    function toScreen(lx, ly, cam, x, gy, tilt) {
      var c = Math.cos(tilt), s = Math.sin(tilt);
      var px = x + (lx * c - ly * s) * S;
      var py = gy + (lx * s + ly * c) * S;
      var fx = W * FX, fy = H * FY;
      return { x: fx + (px - fx) * cam, y: fy + (py - fy) * cam };
    }

    /* Cielo, luna y dunas: se pintan una vez en un lienzo aparte. */
    var bg;
    function buildBackground() {
      if (!W || !H) return;
      bg = document.createElement('canvas');
      bg.width = Math.round(W * dpr);
      bg.height = Math.round(H * dpr);
      var b = bg.getContext('2d');
      b.setTransform(dpr, 0, 0, dpr, 0, 0);
      var sky = b.createLinearGradient(0, 0, 0, H);
      sky.addColorStop(0, '#020101');
      sky.addColorStop(0.42, '#0b0705');
      sky.addColorStop(0.6, '#2a170a');
      sky.addColorStop(0.75, '#110a05');
      sky.addColorStop(1, '#040302');
      b.fillStyle = sky;
      b.fillRect(0, 0, W, H);
      var glow = b.createRadialGradient(W * 0.64, H * 0.61, 0, W * 0.64, H * 0.61, Math.max(W, H) * 0.6);
      glow.addColorStop(0, 'rgba(226,156,74,0.4)');
      glow.addColorStop(0.35, 'rgba(201,122,52,0.11)');
      glow.addColorStop(1, 'rgba(0,0,0,0)');
      b.fillStyle = glow;
      b.fillRect(0, 0, W, H);
      var mx = W * 0.2, my = H * 0.2, mr = Math.max(10, Math.min(W, H) * 0.026);
      var mg = b.createRadialGradient(mx, my, mr, mx, my, mr * 5);
      mg.addColorStop(0, 'rgba(240,226,196,0.08)');
      mg.addColorStop(1, 'rgba(0,0,0,0)');
      b.fillStyle = mg;
      b.beginPath(); b.arc(mx, my, mr * 5, 0, Math.PI * 2); b.fill();
      b.fillStyle = 'rgba(240,226,196,0.9)';
      b.beginPath(); b.arc(mx, my, mr, 0, Math.PI * 2); b.fill();
      b.fillStyle = '#0b0705';
      b.beginPath(); b.arc(mx + mr * 0.42, my - mr * 0.18, mr * 0.92, 0, Math.PI * 2); b.fill();
      paintDune(b, duneBack, '#1a1109', 0.32);
      paintDune(b, duneMid, '#0e0905', 0.42);
      paintDune(b, function (xx) { return groundY(xx); }, '#060403', 0.66);
    }

    function paintDune(b, fn, fill, rimA) {
      b.beginPath();
      b.moveTo(0, H);
      for (var xx = 0; xx <= W + 8; xx += 8) b.lineTo(xx, fn(xx, 0));
      b.lineTo(W, H);
      b.closePath();
      b.fillStyle = fill;
      b.fill();
      b.beginPath();
      for (var x2 = 0; x2 <= W + 8; x2 += 8) {
        var yy = fn(x2, 0);
        if (x2 === 0) b.moveTo(x2, yy); else b.lineTo(x2, yy);
      }
      var rg = b.createLinearGradient(0, 0, W, 0);
      rg.addColorStop(0, 'rgba(' + GOLD + ',0)');
      rg.addColorStop(0.62, 'rgba(' + GOLD + ',' + rimA + ')');
      rg.addColorStop(1, 'rgba(' + GOLD + ',0.04)');
      b.strokeStyle = rg;
      b.lineWidth = 1.1;
      b.stroke();
    }

    function drawSky(t) {
      if (glView) return;
      if (bg) ctx.drawImage(bg, 0, 0, W, H);
      var starIn = prog(t, T.sceneIn, T.sceneFull + 800 * K);
      if (starIn <= 0) return;
      for (var i = 0; i < stars.length; i++) {
        var st = stars[i];
        var tw = 0.55 + 0.45 * Math.sin(t * 0.001 * st.s + st.p);
        ctx.fillStyle = 'rgba(244,236,220,' + (st.a * tw * starIn) + ')';
        ctx.fillRect(st.x, st.y, st.r * 1.6, st.r * 1.6);
      }
    }

    /* La luz del aguijón: núcleo blanco, halo dorado y destello en cruz. */
    function stingLight(x, y, power, scale, thin) {
      if (power <= 0) return;
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      var r = (34 + 70 * power) * scale * (W < 700 ? 0.75 : 1);
      var g = ctx.createRadialGradient(x, y, 0, x, y, r);
      g.addColorStop(0, 'rgba(255,246,226,' + Math.min(1, 0.95 * power) + ')');
      g.addColorStop(0.18, 'rgba(250,214,150,' + 0.55 * power + ')');
      g.addColorStop(0.5, 'rgba(214,150,70,' + 0.18 * power + ')');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(255,240,210,' + 0.8 * Math.min(1, power) + ')';
      ctx.lineWidth = 1 / (thin || 1);
      ctx.beginPath();
      ctx.moveTo(x - r * 2.2, y); ctx.lineTo(x + r * 2.2, y);
      ctx.moveTo(x, y - r * 1.2); ctx.lineTo(x, y + r * 1.2);
      ctx.stroke();
      ctx.restore();
    }

    function drawBars(t, open) {
      var h = Math.round(H * (W < 700 ? 0.07 : 0.1) * (1 - open));
      if (h <= 0) return;
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, W, h);
      ctx.fillRect(0, H - h, W, h);
    }

    function fadeSceneAt(t) { return easeOutCubic(prog(t, T.zoom, T.zoom + 600 * K)); }

    /* --- Cierre en línea ---------------------------------------------- */
    var meta = null;
    function medirLinea() {
      var el = document.querySelector('.antesala__horizonte') || document.querySelector('.portada .horizonte');
      var r = el ? el.getBoundingClientRect() : null;
      if (!r || !r.width || r.bottom < 0 || r.top > H) return { x0: W * 0.3, x1: W * 0.7, y: H * 0.5, cx: W * 0.5 };
      var dot = el.querySelector('.horizonte__luz');
      var dr = dot ? dot.getBoundingClientRect() : null;
      return { x0: r.left, x1: r.right, y: r.top + r.height / 2, cx: dr ? dr.left + dr.width / 2 : (r.left + r.right) / 2 };
    }
    function drawCollapse(u, t) {
      var L = meta || medirLinea();
      var c = screenCtx;
      c.setTransform(dpr, 0, 0, dpr, 0, 0);
      c.globalAlpha = 1;
      c.globalCompositeOperation = 'source-over';
      c.clearRect(0, 0, W, H);
      var v = easeInOut(clamp(u / 0.82, 0, 1));         /* alto: se aplana */
      var h = easeInOut(clamp((u - 0.18) / 0.82, 0, 1)); /* ancho: se ajusta a la línea */
      var top = L.y * v, bot = H - (H - L.y) * v;
      var thick = Math.max(1.2, bot - top);
      var x0 = L.x0 * h, x1 = W - (W - L.x1) * h;
      var a = 1 - 0.55 * v;
      var g = c.createLinearGradient(0, top, 0, bot);
      g.addColorStop(0, 'rgba(201,150,80,' + a * (1 - v) + ')');
      g.addColorStop(0.5, 'rgba(255,240,215,' + a + ')');
      g.addColorStop(1, 'rgba(201,150,80,' + a * (1 - v) + ')');
      c.fillStyle = g;
      if (thick > 3) { c.fillRect(x0, top, x1 - x0, thick); }
      else {
        var lg = c.createLinearGradient(x0, 0, x1, 0);
        lg.addColorStop(0, 'rgba(239,230,214,' + 0.32 * (1 - u) + ')');
        lg.addColorStop(0.5, 'rgba(255,236,206,' + (0.9 - 0.6 * u) + ')');
        lg.addColorStop(1, 'rgba(239,230,214,' + 0.32 * (1 - u) + ')');
        c.fillStyle = lg;
        c.fillRect(x0, L.y - thick / 2, x1 - x0, thick);
      }
      /* el punto: la luz del aguijón queda en el centro */
      var pr = 14 + Math.max(W, H) * 0.5 * (1 - v);
      var pg = c.createRadialGradient(L.cx, L.y, 0, L.cx, L.y, pr);
      pg.addColorStop(0, 'rgba(255,236,206,' + (1 - 0.5 * u) + ')');
      pg.addColorStop(0.25, 'rgba(251,141,69,' + 0.45 * (1 - 0.6 * u) + ')');
      pg.addColorStop(1, 'rgba(221,122,60,0)');
      c.globalCompositeOperation = 'lighter';
      c.fillStyle = pg;
      c.fillRect(L.cx - pr, L.y - pr, pr * 2, pr * 2);
      c.globalCompositeOperation = 'source-over';
    }

    /* --- Cuadro ------------------------------------------------------- */
    var startX = -0.2, endX = W < 700 ? 0.5 : 0.46;
    var prevX = null;
    var frozen = null;
    var revealStart = null;
    var perf = { last: 0, n: 0, sum: 0 };
    /* Si el equipo no sostiene ~50 cuadros por segundo: primero baja el desierto,
       después la nitidez extra del alacrán. Nunca por debajo de la resolución de la pantalla. */
    function adapt(now) {
      if (perf.last) { var dt = now - perf.last; if (dt < 200) { perf.sum += dt; perf.n++; } }
      perf.last = now;
      if (perf.n >= 18) {
        var avg = perf.sum / perf.n;
        if (avg > 19) {
          var base = window.devicePixelRatio || 1;
          if (glView && glView.dpr > 1) { glView.dpr = Math.max(1, glView.dpr - 0.5); sizeGL(); }
          else if (dpr > base) { dprTope = Math.max(base, dpr - 0.5); setDpr2D(dprTope); }
          else if (glView && glView.dpr > 0.75) { glView.dpr = 0.75; sizeGL(); }
        }
        perf.n = 0; perf.sum = 0;
      }
    }

    function frame(now) {
      if (done) return;
      var t = now - t0;

      adapt(now);
      /* Cierre: la luz se aplana hasta volverse la línea del horizonte de la página */
      if (revealStart !== null) {
        var rU = clamp((t - revealStart) / T.revealDur, 0, 1);
        drawCollapse(rU, t);
        if (rU >= 1) { finish(true); return; }
        rafId = requestAnimationFrame(frame);
        return;
      }

      ctx = screenCtx;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';

      /* Pose: caminar, recogerse, atacar */
      var walkU = prog(t, T.walkStart, T.walkEnd);
      var x = W * (startX + (endX - startX) * easeInOutSine(walkU));
      if (prevX === null) prevX = x;
      var dxLocal = (x - prevX) / S;
      prevX = x;
      gait += dxLocal / CYCLE;
      var coil = easeInOut(prog(t, T.walkEnd, T.coilEnd));
      var sU = prog(t, T.strike, T.strikeEnd);
      var strike = sU <= 0 ? 0 : 1 - Math.pow(1 - sU, 4) + Math.sin(sU * Math.PI) * 0.12;
      var pose = {
        moving: clamp(dxLocal * 2.2, 0, 1),
        curl: coil,
        wind: coil * (1 - Math.min(1, strike * 1.4)),
        strike: strike,
        claw: 0.35 + 0.65 * coil
      };
      var lunge = 6 * strike;
      var cam = 1 + 0.12 * easeInOutSine(prog(t, T.walkStart, T.strikeEnd));

      /* Acercamiento hacia la punta encendida */
      var zU = prog(t, T.zoom, T.zoomEnd);
      var zoom = Math.pow(9, Math.pow(zU, 1.15));

      if (glView) ctx.clearRect(0, 0, W, H);
      else { ctx.fillStyle = '#000'; ctx.fillRect(0, 0, W, H); }

      var gy = groundY(x);
      var tilt = Math.atan2(groundY(x + 20 * S) - groundY(x - 20 * S), 40 * S);
      var bx = x + lunge * S;
      var tip = null;
      if (lastG) {
        var a = lastG.telson.a;
        var lx = lastG.telson.x + Math.cos(a) * 19.8 - Math.sin(a) * 10;
        var ly = lastG.telson.y + Math.sin(a) * 19.8 + Math.cos(a) * 10;
        tip = toScreen(lx, ly, cam, bx, gy, tilt);
      }
      if (t >= T.zoom && !frozen && tip) frozen = tip;
      var focus = frozen || tip || { x: W / 2, y: H / 2 };
      var cx = focus.x + (W / 2 - focus.x) * Math.min(1, zU * 1.6);
      var cy = focus.y + (H / 2 - focus.y) * Math.min(1, zU * 1.6);

      if (glView && fadeSceneAt(t) < 0.97) {
        var zz = zoom > 1.0001 ? zoom : 1;
        var gox = W * FX * (1 - cam), goy = H * FY * (1 - cam);
        if (zz > 1) { gox = cx + (gox - focus.x) * zz; goy = cy + (goy - focus.y) * zz; }
        renderGL(t, cam * zz, gox, goy, prog(t, T.sceneIn, T.sceneFull + 800 * K));
      }

      ctx.save();
      if (zoom > 1.0001) { ctx.translate(cx, cy); ctx.scale(zoom, zoom); ctx.translate(-focus.x, -focus.y); }

      var sceneVisible = fadeSceneAt(t) < 0.97;
      ctx.save();
      applyCamera(ctx, cam);
      if (sceneVisible) {
      drawSky(t);

      for (var p = prints.length - 1; p >= 0; p--) {
        var pr = prints[p];
        var age = (now - pr.t) / 3200;
        if (age >= 1) { prints.splice(p, 1); continue; }
        ctx.fillStyle = 'rgba(190,140,90,' + (0.1 * (1 - age)) + ')';
        ctx.beginPath(); ctx.ellipse(pr.x, pr.y + 1.5, 1.4, 0.55, 0, 0, Math.PI * 2); ctx.fill();
      }

      if (t >= T.walkStart - 200) {
        var sh = ctx.createRadialGradient(bx, gy + 2, 0, bx, gy + 2, 70 * S);
        sh.addColorStop(0, 'rgba(0,0,0,0.65)');
        sh.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.save();
        ctx.translate(bx, gy + 2); ctx.scale(1, 0.09); ctx.translate(-bx, -(gy + 2));
        ctx.fillStyle = sh;
        ctx.beginPath(); ctx.arc(bx, gy + 2, 70 * S, 0, Math.PI * 2); ctx.fill();
        ctx.restore();

        ctx.save();
        ctx.translate(bx, gy);
        ctx.rotate(tilt);
        ctx.scale(S, S);
        lastG = drawScorpion(t, pose);
        ctx.restore();
      }

      for (var li = 0; li < 4; li++) {
        var f = footAt(li, false);
        if (f.stance && !lastStance[li] && pose.moving > 0.05) {
          var wx = x + f.x * S * Math.cos(tilt);
          var wy = groundY(wx);
          prints.push({ x: wx, y: wy, t: now });
          for (var dd = 0; dd < 3; dd++) dust.push({ x: wx, y: wy, vx: rand(-12, 5), vy: rand(-14, -4), life: 0, max: rand(600, 1000) });
        }
        lastStance[li] = f.stance;
      }
      if (sU > 0 && sU < 0.2 && !frame.kicked) {
        frame.kicked = true;
        for (var k2 = 0; k2 < 26; k2++) dust.push({ x: bx + rand(-30, 40) * S, y: gy, vx: rand(-30, 30), vy: rand(-36, -8), life: 0, max: rand(700, 1300) });
      }
      for (var di = dust.length - 1; di >= 0; di--) {
        var d = dust[di];
        d.life += 16;
        if (d.life > d.max) { dust.splice(di, 1); continue; }
        d.x += d.vx * 0.016; d.y += d.vy * 0.016; d.vy += 0.4;
        ctx.fillStyle = 'rgba(205,160,110,' + (0.35 * (1 - d.life / d.max)) + ')';
        ctx.fillRect(d.x - 0.8, d.y - 0.8, 1.6, 1.6);
      }

      for (var mi = 0; mi < motes.length; mi++) {
        var mo = motes[mi];
        mo.x += mo.v * 0.016;
        if (mo.x > W * 1.1) mo.x = -W * 0.1;
        var yy2 = mo.y + Math.sin(t * 0.0008 + mo.p) * 5;
        ctx.fillStyle = 'rgba(215,175,125,' + mo.a * 0.7 * (0.6 + 0.4 * Math.sin(t * 0.0016 + mo.p)) + ')';
        ctx.fillRect(mo.x, yy2, mo.r * 1.6, mo.r * 1.6);
      }
      }
      ctx.restore();

      /* Al entrar en la luz, todo lo demás se apaga */
      var fadeScene = fadeSceneAt(t);
      if (fadeScene > 0) {
        ctx.save();
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.fillStyle = 'rgba(0,0,0,' + (sceneVisible ? 0.94 * fadeScene : 1) + ')';
        ctx.fillRect(0, 0, W, H);
        ctx.restore();
      }

      /* La punta del aguijón se enciende con el ataque */
      var ignite = easeOutCubic(prog(t, T.strike + 90 * K, T.strikeEnd + 60 * K));
      var pulse = 0.9 + 0.1 * Math.sin(t * 0.012);
      var lightAt = frozen || tip;
      if (lightAt && ignite > 0) stingLight(lightAt.x, lightAt.y, ignite * pulse * (1 + zU * 0.6), 1, zoom);
      ctx.restore();

      if (zU > 0 && !frame.enLuz) { frame.enLuz = true; root.classList.add('en-luz'); }

      /* Al final del acercamiento la luz llena la pantalla */
      var flood = easeInOut(prog(t, T.zoom + 450 * K, T.zoomEnd));
      if (flood > 0) {
        var fl = ctx.createRadialGradient(W / 2, H / 2, 0, W / 2, H / 2, Math.max(W, H) * (0.2 + 0.9 * flood));
        fl.addColorStop(0, 'rgba(255,246,228,' + flood + ')');
        fl.addColorStop(0.45, 'rgba(240,206,140,' + flood * 0.95 + ')');
        fl.addColorStop(1, 'rgba(201,150,80,' + flood * flood + ')');
        ctx.fillStyle = fl;
        ctx.fillRect(0, 0, W, H);
      }

      /* Apertura: negro y línea de horizonte */
      var black = 1 - easeInOut(prog(t, T.sceneIn, T.sceneFull));
      if (black > 0) { ctx.fillStyle = 'rgba(0,0,0,' + black + ')'; ctx.fillRect(0, 0, W, H); }
      var lineA = 1 - prog(t, T.sceneFull - 200 * K, T.sceneFull + 400 * K);
      if (lineA > 0) {
        var lw = W * 0.92 * easeInOut(prog(t, 150 * K, T.lineFull));
        var ly0 = H * 0.6;
        var lg = ctx.createLinearGradient(W / 2 - lw / 2, 0, W / 2 + lw / 2, 0);
        lg.addColorStop(0, 'rgba(' + GOLD + ',0)');
        lg.addColorStop(0.5, 'rgba(250,224,170,' + lineA + ')');
        lg.addColorStop(1, 'rgba(' + GOLD + ',0)');
        ctx.fillStyle = lg;
        ctx.fillRect(W / 2 - lw / 2, ly0 - 0.6, lw, 1.2);
        var halo = ctx.createRadialGradient(W / 2, ly0, 0, W / 2, ly0, lw * 0.35 + 1);
        halo.addColorStop(0, 'rgba(226,170,92,' + 0.22 * lineA + ')');
        halo.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = halo;
        ctx.fillRect(0, ly0 - lw * 0.35, W, lw * 0.7);
      }

      /* Franjas de cine */
      drawBars(t, easeInOut(prog(t, T.zoom, T.zoomEnd)));

      /* La luz se vuelve la línea del horizonte de la tienda */
      if (revealStart === null && t >= T.reveal && (loaded || t >= T.reveal + 3500)) {
        revealStart = t;
        html.classList.add('intro-linea');
        html.classList.remove('intro-activa');
        root.classList.add('is-linea');
        meta = medirLinea();
      }

      rafId = requestAnimationFrame(frame);
    }
    rafId = requestAnimationFrame(frame);
  }
})();
